import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { ButtonLink } from '../ui/ButtonLink';
import { SearchAreasList } from '../ui/SearchAreasList';
export function HomeBoardSearch() {
  return <section className="bg-white" aria-labelledby="board-title" data-id="element-152" data-mp="39nr3sz4mgu75">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:gap-12 lg:py-32" data-id="element-153" data-mp="3en3ww1m36xi6">
        <div className="lg:col-span-5" data-id="element-154" data-mp="2gzlgc4m6or3m">
          <SectionHeading id="board-title" eyebrow="Leadership & Board Search" title="Board and senior leadership appointments, handled with care." intro="Appointments at board and C-suite level carry governance, reputational and strategic weight. We approach them with additional rigour — and a clear understanding of what the board or leadership team needs." data-id="element-155" data-mp="2h0n0qzp3apy0" />
          <ButtonLink to="/leadership-board-search" variant="outlineDark" className="mt-10" data-id="element-156" data-mp="670mvp7i4wqo">
            Explore Leadership & Board Search
          </ButtonLink>
        </div>
        <div className="lg:col-span-7" data-id="element-157" data-mp="3oj08pzzvoaqv">
          <p className="mb-2 text-sm font-medium text-muted" data-id="element-158" data-mp="3ohxgnoqtk29d">Areas in which we search</p>
          <SearchAreasList data-id="element-159" data-mp="3jj401ng8jv4z" />
        </div>
      </div>
    </section>;
}